module.exports = __webpack_public_path__ + "fromGroomToMother-jp-w.bb4e7611.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToMother-jp-w.jpg
// module id = HuKm
// module chunks = 0